import * as am5 from '@amcharts/amcharts5';
import { Root } from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import { XYChart } from '@amcharts/amcharts5/xy';
import { Injectable } from '@angular/core';
import {
    datGrey,
    datiqFontFamilyCaption,
} from '@dat/datiq-components-pkg/utils';
import {
    IDatiqGraph,
    IDatiqGraphAxis
} from '../models';
import { DatiqAmcharts5AxisDateService } from './datiq-amcharts-5-axis-date.service';
import { DatiqAmcharts5AxisUtilsService } from './datiq-amcharts-5-axis-utils.service';
import { DatiqAmcharts5UtilsService } from './datiq-amcharts-5-utils.service';

@Injectable({
    providedIn: 'root',
})
export class DatiqAmcharts5AxisCategoryService {
    constructor(
        private _utils: DatiqAmcharts5AxisUtilsService,
        private _amUtil: DatiqAmcharts5UtilsService,
        private _date: DatiqAmcharts5AxisDateService
    ) {}

    createXAxis(
        root: Root,
        chart: XYChart,
        axis: IDatiqGraphAxis,
        settings: IDatiqGraph
    ): am5xy.Axis<am5xy.AxisRendererX> {
        const renderer = this._utils.setXAxisRenderer(root, axis);
        const axisX: am5xy.CategoryAxis<am5xy.AxisRendererX> = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: 'x',
                renderer,
                maxWidth: axis?.maxWidth ?? 10000,
            })
        );
        if (axis?.truncateLabels) this._utils.truncateXAxisLabels(axisX);

        return this.setGridLabelFormatting(renderer).buildXAxis(axisX);
    }
    buildXAxis(
        axisX: am5xy.CategoryAxis<am5xy.AxisRendererX>
    ): am5xy.Axis<am5xy.AxisRendererX> {
        return axisX;
    }
    setGridLabelFormatting(renderer: am5xy.AxisRendererX) {
        this._utils.setDefaultLabelStyles(renderer);
        renderer.labels.template.setAll({
            rotation: 60,
            dx: 16,
        });

        return this;
    }
    addAxisToolTip(
        root: Root,
        axis: IDatiqGraphAxis,
        axisX: am5xy.CategoryAxis<am5xy.AxisRendererX>
    ) {
        const tooltip = am5.Tooltip.new(root, {
            rotation: 60,
            paddingBottom: 4,
            paddingTop: 4,
            paddingLeft: 4,
            paddingRight: 4,
            layer: 0,
        });

        tooltip.get('background').setAll({
            fill: this._amUtil.setColor(datGrey['200']),
            layer: 0,
        });

        tooltip.label.setAll({
            fontSize: datiqFontFamilyCaption.fontSize,
            fontWeight: datiqFontFamilyCaption.fontWeight,
        });

        axisX.set('tooltip', tooltip);

        return this;
    }
}
